import type { EopMailboxStatus } from "@/features/eop_mail/api/mailbox";

/**
 * Skuteczność warstw rozpoznawania — po to, żeby nie trzeba było wierzyć na słowo.
 *
 * Automat przypina sam (decyzja z 16.08.2026), więc miara się zmieniła:
 * „Przypięła" mówi, ile przypięć warstwy aktualnie stoi. „Potwierdzone" to jawne
 * kliknięcia w to samo przedsięwzięcie, „Poprawione" — twardy licznik pomyłek,
 * czyli przypięć zmienionych przez człowieka na inne. Warstwa z rosnącym
 * „Poprawione" to kandydat do przykręcenia progów, i ma być tak samo widoczna
 * jak ta, która działa.
 */
export function TaggingScorecard({ status }: { status: EopMailboxStatus }) {
  const layers = (status.tagging?.layers ?? []).filter(
    (layer) => layer.assigned > 0 || layer.accepted > 0 || layer.corrected > 0,
  );
  const byHand = status.tagging?.assigned_by_hand ?? 0;

  if (layers.length === 0 && byHand === 0) {
    return (
      <p className="text-[11px] text-[var(--color-text-muted)]">
        Za mało danych, żeby ocenić rozpoznawanie — nic jeszcze nie zostało
        przypięte.
      </p>
    );
  }

  return (
    <div className="space-y-1">
      <table className="w-full text-[11px]">
        <thead>
          <tr className="text-[var(--color-text-muted)]">
            <th className="section-label py-1 text-left">Warstwa</th>
            <th className="section-label py-1 text-right">Przypięła</th>
            <th className="section-label py-1 text-right">Potwierdzone</th>
            <th className="section-label py-1 text-right">Poprawione</th>
          </tr>
        </thead>
        <tbody>
          {layers.map((layer) => (
            <tr key={layer.source} className="border-t border-[var(--color-border)]">
              <td className="py-1 text-[var(--color-text-secondary)]">{layer.label}</td>
              <td className="py-1 text-right font-mono">{layer.assigned}</td>
              <td className="py-1 text-right font-mono">{layer.accepted}</td>
              <td
                className={`py-1 text-right font-mono ${
                  layer.corrected > 0 ? "text-[var(--color-primary)]" : ""
                }`}
              >
                {layer.corrected}
              </td>
            </tr>
          ))}
          <tr className="border-t border-[var(--color-border)]">
            <td className="py-1 text-[var(--color-text-muted)]">
              wskazane ręcznie, bez podpowiedzi
            </td>
            <td className="py-1 text-right font-mono">—</td>
            <td className="py-1 text-right font-mono">{byHand}</td>
            <td className="py-1 text-right font-mono">—</td>
          </tr>
        </tbody>
      </table>
      <p className="text-[10px] text-[var(--color-text-muted)]">
        „Poprawione" liczy przypięcia automatu zmienione przez człowieka na inne
        przedsięwzięcie — to jedyny twardy sygnał pomyłki. Milczenie przy
        „Przypięła" czytamy ostrożnie jako zgodę.
      </p>
    </div>
  );
}
